import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { CloudType, CloudTypeEnum, setSelectedAccount } from '@labrav/common'

import { setCloudMarketplaceProductListing } from '../../../modules/productListingFilter/action'

/**
 * Syncs route params (cloud, accountId) to selectedAccountIds for FLYOUT.
 * Call in components that use the :cloud/:accountId route pattern.
 */
export const useSyncFlyoutRouteParams = (skip?: boolean) => {
  const dispatch = useDispatch()
  const { cloud: routeCloud, accountId: routeAccountId } = useParams<{
    cloud?: string
    accountId?: string
  }>()

  useEffect(() => {
    if (!skip && routeAccountId && routeCloud) {
      const routeCloudUpper = routeCloud.toUpperCase() as CloudType
      const validClouds: CloudType[] = [
        CloudTypeEnum.AWS,
        CloudTypeEnum.AZURE,
        CloudTypeEnum.GCP,
        CloudTypeEnum.REDHAT,
      ]
      if (!validClouds.includes(routeCloudUpper)) {
        console.warn(`Invalid cloud param: ${routeCloud}`)
        return
      }
      dispatch(
        setSelectedAccount(routeAccountId, 'flyout', routeCloudUpper) as never
      )
      dispatch(setCloudMarketplaceProductListing(routeCloudUpper) as never)
    }
  }, [routeAccountId, routeCloud, dispatch, skip])
}
